module.exports = __webpack_public_path__ + "img/prepsol.2c51f880.png";